export const OFFICE_VISUAL_CLASSIC = 'classic';
export const OFFICE_VISUAL_MODERN = 'modern';

// The approved general release applies presentation to every account and public access page.
// Historical per-account preferences do not change permissions, theme or accent.
export function resolveOfficeVisual() {
  return OFFICE_VISUAL_MODERN;
}

export function usesModernOfficeVisual(user) {
  return resolveOfficeVisual(user) === OFFICE_VISUAL_MODERN;
}
